/**
 * LocationBanner — предупреждение о важности текущего местоположения
 *
 * Показывается на страницах прогнозов, когда текущая локация не определена.
 */

import React from 'react';

interface LocationBannerProps {
  currentCity: string | null;
  onUpdateClick: () => void;
}

const LocationBanner: React.FC<LocationBannerProps> = ({ currentCity, onUpdateClick }) => {
  if (currentCity) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '8px 16px',
        background: 'rgba(212, 175, 55, 0.06)',
        border: '1px solid rgba(212, 175, 55, 0.12)',
        borderRadius: '12px',
        marginBottom: '16px',
        fontSize: '13px',
        color: '#a0a0a0',
      }}>
        <span>📍</span>
        <span>Прогноз для: <strong style={{ color: '#d4af37' }}>{currentCity}</strong></span>
        <button
          onClick={onUpdateClick}
          style={{
            background: 'none',
            border: 'none',
            color: '#888',
            fontSize: '12px',
            cursor: 'pointer',
            textDecoration: 'underline',
            marginLeft: '4px',
          }}
        >
          изменить
        </button>
      </div>
    );
  }

  return (
    <div style={{
      padding: '16px 20px',
      background: 'rgba(255, 107, 107, 0.06)',
      border: '1px solid rgba(255, 107, 107, 0.15)',
      borderRadius: '16px',
      marginBottom: '20px',
      textAlign: 'center',
    }}>
      <p style={{
        color: '#e0e0e0',
        fontSize: '14px',
        margin: '0 0 4px',
        lineHeight: 1.6,
      }}>
        ⚠️ <strong>Текущее местоположение не определено</strong>
      </p>
      <p style={{
        color: '#a0a0a0',
        fontSize: '13px',
        margin: '0 0 12px',
        lineHeight: 1.5,
      }}>
        Точные прогнозы (транзиты по домам, Solar Return) зависят от вашего текущего места.
        Без него расчёты могут быть неточными.
      </p>
      <button
        onClick={onUpdateClick}
        style={{
          background: 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
          border: 'none',
          padding: '8px 20px',
          borderRadius: '20px',
          color: '#0a0814',
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Указать местоположение
      </button>
    </div>
  );
};

export default LocationBanner;
